<template>
    <span>
        <template v-if="details.present">
            <button :id="eventId" type="button" class="btn btn-link btn-sm p-0"
                :class="event === 'bounced_ts' ? 'text-danger' : 'text-success'"
                :aria-label="details.label + (details.date ? ': ' + formatDateTime(details.date) : '')">
                <i :class="details.icon" aria-hidden="true"></i>
            </button>
            <b-popover :target="eventId" triggers="hover focus" placement="auto" :title="details.label">
                <div v-if="details.date">{{ formatDateTime(details.date) }}</div>
                <div v-if="details.message" style="white-space: pre-wrap;">{{ details.message }}</div>
            </b-popover>
        </template>
        <span v-else class="text-muted" :aria-label="details.label + ': ingen registrerad händelse'">–</span>
    </span>
</template>

<script>
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'RecipientEvent',
    props: {
        row: { type: Object, required: true },
        event: { type: String, required: true },
    },
    computed: {
        details() {
            const { row, event } = this;
            const sms = row.delivery_channel === 'sms';
            const events = {
                sent_ts: { label: 'Skickat', icon: 'icon-paperplane', date: sms ? row.sms_sent_ts : row.email_sent_ts },
                delivered_ts: {
                    label: 'Levererad', icon: 'icon-checkmark4', date: sms ? row.sms_delivered_ts : row.delivered_ts,
                },
                opened_ts: {
                    label: 'Öppnad', icon: 'icon-eye', date: row.opened_ts, emailOnly: true,
                },
                clicked_ts: {
                    label: 'Klickat', icon: 'icon-touch', date: row.clicked_ts, emailOnly: true,
                },
                is_redeemed: {
                    label: 'Inlöst', icon: 'icon-check', present: !!Number(row.is_redeemed), message: 'Kortet är inlöst.',
                },
                bounced_ts: {
                    label: sms ? 'Leveransfel' : 'Bounce',
                    icon: 'icon-reply',
                    date: sms ? row.sms_failed_ts : row.bounced_ts,
                    message: sms ? row.sms_failed_msg : row.bounced_msg,
                },
            };
            const details = events[event];
            return {
                ...details,
                present: !(sms && details.emailOnly) && (details.present ?? !!details.date),
            };
        },
        eventId() { return `ecard-recipient-event-${this._uid}`; },
    },
    methods: { formatDateTime },
};
</script>
